import * as React from "react";
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";

import HourglassBottom from "@mui/icons-material/HourglassBottom";
import PriorityHigh from "@mui/icons-material/PriorityHigh";
import Done from "@mui/icons-material/Done";
import Clear from "@mui/icons-material/Clear";
import Typography from "@mui/material/Typography";

export default function MDStatusStepper({ transaction }) {
  return (
    <Timeline
      sx={{
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          padding: 0,
        },
      }}
    >
      <TimelineItem
        sx={{ opacity: transaction?.status === "pending" ? 1 : 0.2 }}
      >
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot color="info">
            <PriorityHigh />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: "12px", px: 2 }}>
          <Typography
            variant={transaction?.status === "pending" ? "h5" : "h6"}
            component="span"
            color={transaction?.status === "pending" ? "dark" : "light"}
          >
            Pending
          </Typography>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem
        sx={{ opacity: transaction?.status === "processing" ? 1 : 0.2 }}
      >
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot color="primary">
            <HourglassBottom />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: "12px", px: 2 }}>
          <Typography
            variant={transaction?.status === "processing" ? "h5" : "h6"}
            component="span"
            color={transaction?.status === "processing" ? "dark" : "light"}
          >
            Processing
          </Typography>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem
        sx={{ opacity: transaction?.status === "completed" ? 1 : 0.2 }}
      >
        <TimelineSeparator>
          <TimelineConnector />
          <TimelineDot color="success">
            <Done color="white" />
          </TimelineDot>
          <TimelineConnector sx={{ bgcolor: "secondary.main" }} />
        </TimelineSeparator>
        <TimelineContent sx={{ py: "12px", px: 2 }}>
          <Typography
            variant={transaction?.status === "completed" ? "h5" : "h6"}
            component="span"
            color={transaction?.status === "completed" ? "dark" : "light"}
          >
            Completed
          </Typography>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem
        sx={{ opacity: transaction?.status === "rejected" ? 1 : 0.2 }}
      >
        <TimelineSeparator>
          <TimelineConnector sx={{ bgcolor: "secondary.main" }} />
          <TimelineDot color="dark">
            <Clear color="white" />
          </TimelineDot>
          <TimelineConnector />
        </TimelineSeparator>
        <TimelineContent sx={{ py: "12px", px: 2 }}>
          <Typography
            variant={transaction?.status === "rejected" ? "h5" : "h6"}
            component="span"
            color={transaction?.status === "rejected" ? "dark" : "light"}
          >
            Rejected
          </Typography>
        </TimelineContent>
      </TimelineItem>
    </Timeline>
  );
}
